module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kg-Ld.c29f0e83.png";